@if (evaluationResult(); as evalResult) {
  @let isValid = validResult() && !!evalResult?.valid;
  <div
    class="formula-evaluation-result"
    [class.has-error]="!isValid"
    [class.has-success]="isValid && $safeNavigationMigration(evalResult?.result) !== null && $safeNavigationMigration(evalResult?.result) !== undefined"
    data-test="formula-evaluation-result"
  >
    <div class="fer-header">
      <mat-icon>{{
        isValid && $safeNavigationMigration(evalResult?.result) !== null && $safeNavigationMigration(evalResult?.result) !== undefined
          ? 'check_circle_outline'
          : 'error_outline'
      }}</mat-icon>
      <span class="fer-header__title">{{ 'I18N_FORMULA.EVALUATION.TITLE' | translate }}</span>
    </div>

    <!-- Normalized expression -->
    <div class="fer-row" data-test="formula-evaluation-normalized">
      <code class="fer-code">{{ evalResult.normalizedExpression || '—' }}</code>
    </div>

    <!-- Result -->
    <div class="fer-result-row" data-test="formula-evaluation-result-value">
      @if (!evalResult.valid) {
        <span class="fer-error-msg">
          {{ evalResult.errorKey ? (evalResult.errorKey | translate: evalResult.errorParams) : evalResult.error }}
        </span>
      } @else {
        <span class="fer-label">{{ 'I18N_FORMULA.EVALUATION.RESULT' | translate }}</span>
        @if (isValid) {
          <span class="fer-result-value">{{ evalResult.result }}</span>
        } @else {
          <span class="fer-result-value">{{ '—' }}</span>
        }
      }
    </div>
  </div>
}
